// Aviso de nueva versión de la PWA (registerType: 'prompt' en vite.config.ts).
//
// Por qué: con 'autoUpdate' el service worker nuevo se activa solo tras un
// SEGUNDO refresh (el primero solo "descarga" la versión nueva) y, si en algún
// momento se recarga automáticamente, el usuario puede perder el estado de un
// formulario abierto en una pestaña keep-alive (useTabsStore). Con 'prompt' el
// usuario decide CUÁNDO actualizar: un solo clic aplica la versión nueva
// (skipWaiting) y recarga.
//
// No renderiza nada visible salvo cuando hay una versión nueva disponible.
import { useEffect } from 'react';
import { toast } from 'sonner';
import { useRegisterSW } from 'virtual:pwa-register/react';

const TOAST_ID = 'pwa-nueva-version';

export function PwaUpdater() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      // Chequeo periódico: si el servidor ya tiene una build nueva, el SW
      // pasa a needRefresh=true sin que el usuario tenga que recargar la app.
      if (!registration) return;
      const interval = setInterval(() => {
        void registration.update();
      }, 60_000);
      // No hay cleanup aquí porque onRegisteredSW corre una sola vez por
      // registro del SW (no dentro de un efecto de React); el intervalo vive
      // mientras la pestaña esté abierta, igual que el propio SW.
      window.addEventListener('beforeunload', () => clearInterval(interval), { once: true });
    },
  });

  useEffect(() => {
    if (!needRefresh) {
      toast.dismiss(TOAST_ID);
      return;
    }

    toast('Hay una nueva versión disponible.', {
      id: TOAST_ID,
      duration: Infinity,
      description: 'Actualiza para obtener las últimas mejoras y correcciones.',
      action: {
        label: 'Actualizar',
        onClick: () => {
          void updateServiceWorker(true);
        },
      },
    });
  }, [needRefresh, updateServiceWorker]);

  return null;
}
